import React from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import Button from '../../common/components/button/Button';
import TextInput from '../../common/components/textinput/TextInput';
import { media } from '../../common/components/ui/utils';
import Icon from '../../common/components/icon/Icon';
import { ICONS } from '../../common/components/icon/Icons';
import colors from '../../common/components/ui/colors';

import Legend from '../../common/components/legend/Legend';

const Form = styled.form`
  text-align: left;
  label{
    color: ${colors.GRAY_DARK};
  }
`;

const Fieldset = styled.div`
  position: relative;
  background-color: ${props => props.theme.TextInput_background_color};
  border-radius: 3px;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-flow: row wrap;
  
  margin: 0 auto;

  svg {
    opacity: ${props => props.theme.TextInputSearch_icon_opacity};
    fill: ${props => props.theme.TextInputSearch_icon_color};
    ${media.tabletNarrow`
      padding: 0 0;
    `} ${media.phoneWide`
      flex:0 0 10%;
    `} flex:0 0 15%;
    max-height: 1.625rem;
  }
`;

const FilterLegend = styled(Legend)`padding-right: 1em;`;

const DescriptionContainer = styled.div`
  padding: 0.5rem 1.5rem;
  box-sizing: content-box;
  height: 2rem;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.25rem;
  color: ${colors.WHITE};
  a {
    text-decoration: underline;
  }
`;

const SearchInput = styled(TextInput)`
  border: 0;
  color: ${props => props.theme.TextInputSearch_color};
  margin-bottom: 0;
  flex: 0 0 85%;
  ${media.phoneWide`
    flex:0 0 90%;
  `} ${media.tabletNarrow`
    flex: 1;
    height: 100%;
  `} input {
    color: inherit !important;
    font-size: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    &::-webkit-input-placeholder {
      color: ${props => props.theme.TextInputSearch_placeholder_color};
    }
  }
  svg {
    height: 2rem;
  }

  &[disabled] {
    border-color: transparent !important;
  }
`;

const AutoCompleteInput = styled(SearchInput)`
  position: relative;
`;

const FieldsetMin = styled.div`
  position: relative;
  display: flex;
  border-radius: 3px;
  flex-direction: row;
  justify-content: center;
  background-color: white;
  align-items: center;
  padding: calc(6rem / 16);
  
  svg {
    pointer-events: none;
    opacity: ${props => props.theme.TextInputSearch_icon_opacity};
    fill: ${props => props.theme.TextInputSearch_icon_color};
    width: 15px;
    position: absolute;
    left: calc(14rem / 16);
    max-height: 20px;
    ${media.tabletNarrow`
      font-size: calc(18em / 16);
      width: 20px;
    `}
  }
  
  .searchform__input{
    display: block;
    flex: 1;
    font-size: 1rem;
    padding-left: 34px;
    margin-left: 0px;
    margin-right: calc(6rem / 16);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 6px);
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    ${media.tabletNarrow`
      padding-left: 44px;
      font-size: calc(18em / 16);
    `}
  }

  .btn{
    font-size: calc(12rem / 16);
    padding-left: 10px;
    padding-right: 10px;
    ${media.tabletNarrow`
      font-size: 1rem;
      padding-left: 15px;
      padding-right: 15px;
    `}
  }

`;

const AutoCompleteInputMin = styled(AutoCompleteInput)`
  position: static;
  display: block;
  flex: 1;
  input{
    font-size: 1rem;
    padding-left: 34px;
    margin-left: 0px;
    margin-right: calc(6rem / 16);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 6px);
    ${media.tabletNarrow`
      padding-left: 44px;
      font-size: calc(18em / 16);
    `}
  }
  ul {
    top: calc(100% - 2px);
    border: 0;
    padding: 0;
    border-radius: 0;
    font-size: calc(18rem / 16);
    box-shadow: 0 1px 12px 0 rgba(0,0,0,0.15);
    border: 1px solid ${colors.BORDER_COLOR};
    li {
      padding: calc(10rem / 16) calc(18rem / 16);
      border-top: 1px solid ${colors.BORDER_COLOR};
      cursor: pointer;
      &:first-child{
        border: none;
      }
    }
  }
`;

const CancelButton = styled(Button)`
  background-color: transparent;
  border-width: 1px;
  border-style: solid;
  border-color: #9b9b9b;
  color: #4a4a4a;

  font-weight: bold;
  padding: calc(0.75rem - 2px);
`;

const SubmitText = styled.span`
  color: #ffffff;
  font-weight: 700;
  text-transform: uppercase;
  flex: 1;
  text-align: center;
  margin-right: 1em;
`;
const SubmitButtonBackground = styled.span`
  line-height: 3rem;
  text-align: center;
  flex: 0 0 100%;
  cursor: pointer;

  ${media.tabletNarrow`
    line-height: 3.875rem;
    flex: 0 0 62px;
  `} border-radius: 3px;
  background: ${colors.FIELD_ERROR};
  overflow: hidden;
  width: 100%;
  svg {
    fill: #fff;
    //flex-basis: 62px;
    height: 1.25rem;
    width: 0.75rem;
  }
  .current-input-touch & {
    &:active:not([disabled]) {
      background: #e86a76;
    }
  }

  .current-input-mouse & {
    &:hover:not([disabled]) {
      background: #e86a76;
    }
  }
`;

const SubmitButton = styled(({ onClick, children, ...rest }) => {
  return (
    <SubmitButtonBackground onClick={onClick}>
      <MediaQuery maxWidth={767}>
        <SubmitText>{children}</SubmitText>
      </MediaQuery>
      <Icon icon={ICONS.ARROW_RIGHT} width="14px" height="14px" />
    </SubmitButtonBackground>
  );
})`

`;


const ButtonGroup = styled.div`
  display: flex;
  margin-top: 1em;
  justify-content: space-around;
  width: 100%;
  > button,
  span {
    flex: 0 0 50%;
  }
`;

const Placeholder = styled.div`
  display: flex;
  width: 100%;
  border-radius: 3px;
  overflow: hidden;
  flex-flow: row wrap;
  background: white;
  border-radius: 3px;
  height: 3rem;
  ${media.tabletNarrow`
    height: 3.875rem;
  `};
`;

const PlaceholderButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 0;
  text-transform: uppercase;
  font-weight: bold;
  width: 100%;

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    ${media.phoneWide`
      font-size: 0.9375rem;
    `} color: ${colors.BRAND_GREEN};
    font-size: 0.8125rem;
    .current-input-mouse & {
      &:hover {
        color: #6ca827;

        svg {
          fill: #6ca827;
        }
      }
    }

    svg {
      height: 1.125rem;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: unset;
      width: 1rem;
      margin-left: 0.5em;
      fill: ${colors.BRAND_GREEN};
    }
  }
`;

export default {
  Form,
  Fieldset,
  FieldsetMin,
  FilterLegend,
  DescriptionContainer,
  AutoCompleteInput,
  SearchInput,
  AutoCompleteInputMin,
  Placeholder,
  PlaceholderButton,
  SubmitButton,
  CancelButton,
  ButtonGroup,
};



// WEBPACK FOOTER //
// ./src/modules/search/ui/SearchForm.js